export default __webpack_public_path__ + "static/media/goOne-logo.5b1608ee.png";